import React, { useState, useEffect } from 'react';

interface MessengerFloatingButtonProps {
  chatUrl: string;
}

const MessengerFloatingButton: React.FC<MessengerFloatingButtonProps> = ({
  chatUrl,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Show/hide based on scroll direction
      if (currentScrollY > lastScrollY) {
        setIsVisible(false); // Scrolling down, hide
      } else {
        setIsVisible(true); // Scrolling up, show
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  const handleOpenChat = () => {
    window.open(chatUrl, '_blank');
  };

  return (
    <div
      className={`fixed z-50 transition-all duration-500 ease-in-out ${
        isVisible
          ? 'right-6 bottom-28 opacity-100 translate-y-0'
          : 'right-6 bottom-10 opacity-0 translate-y-10'
      }`}
    >
      <button
        onClick={handleOpenChat}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className={`${
          isHovered ? 'w-auto pl-4 pr-5' : 'w-14'
        } h-14 bg-[#0068FF] hover:bg-[#0055cc] text-white rounded-full shadow-lg transition-all duration-300 ease-in-out flex items-center justify-center transform hover:scale-105 hover:shadow-xl`}
        aria-label='Chat với chúng tôi qua Zalo'
      >
        <svg
          className='h-7 w-7 flex-shrink-0'
          fill='currentColor'
          viewBox='0 0 24 24'
        >
          <path d='M12 2C6.48 2 2 6.03 2 11.25c0 2.55 1.19 4.84 3.05 6.36L3.5 21.5l4.55-1.5c1.28.35 2.63.54 3.95.54 5.52 0 10-4.03 10-9.25S17.52 2 12 2zm0 16c-1.15 0-2.27-.2-3.32-.58l-.24-.09-2.44 1.01 1.02-2.38-.16-.24C5.82 14.36 5 12.86 5 11.25 5 7.69 8.13 5 12 5s7 2.69 7 6.25-3.13 6.25-7 6.25z' />
        </svg>
        {isHovered && (
          <span className='ml-2 whitespace-nowrap font-medium'>
            Chat với chúng tôi
          </span>
        )}
      </button>
    </div>
  );
};

export default MessengerFloatingButton;
